if (window.Sentry) {
    window.Sentry.init({
        dsn: window.SENTRY_DSN,
        environment: window.APP_ENV,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: false,
            })
        ],
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event, hint) {
            if (event.exception && event.exception.values[0]) {
                const error = event.exception.values[0];
                
                if (error.value?.match(/Component not found: .+/)) {
                    return null;
                }
                
                if (error.stacktrace?.frames) {
                    const frames = error.stacktrace.frames;
                    const ignoredDomains = [
                        'chrome-extension://',
                        'moz-extension://',
                        'safari-extension://',
                    ];
                    
                    if (frames.some(frame => 
                        ignoredDomains.some(domain => frame.filename?.includes(domain))
                    )) {
                        return null;
                    }
                }
            }
            
            if (hint.originalException) {
                if (hint.originalException.name === 'NetworkError') {
                    return null;
                }
            }
            
            return event;
        },
        ignoreErrors: [
            /ResizeObserver/,
            /^chrome:\/\//,
            /^moz-extension:\/\//,
        ],
        denyUrls: [
            /^chrome:\/\//,
            /^moz-extension:\/\//,
            /^safari-extension:\/\//,
        ],
    });
} 